import { useMemo, useState } from "react";
import SectionHeading from "@/components/base/SectionHeading";
import MediaCard from "@/components/base/MediaCard";
import { allMedia } from "@/lib/media";
import { MEDIA_TYPE_LABEL, type MediaType } from "@/types/media";

const tabs: { key: MediaType; label: string }[] = [
  { key: "movie", label: "电影" },
  { key: "tvshow", label: "电视剧" },
  { key: "show", label: "综艺" },
];

export default function LatestMediaSection() {
  const [tab, setTab] = useState<MediaType>("movie");

  const list = useMemo(
    () =>
      allMedia
        .filter((item) => item.type === tab)
        .sort((a, b) => Number(b.year) - Number(a.year))
        .slice(0, 8),
    [tab],
  );

  return (
    <section className="mx-auto mt-16 max-w-[1280px] px-4 md:mt-20 md:px-8">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <SectionHeading
          eyebrow="最新影视资源"
          title="新片速递 · 抢先了解"
          desc="按上线时间倒序整理的影视精选，涵盖电影、电视剧与热门综艺。"
        />
        <div className="mb-6 flex items-center gap-1 rounded-full border border-background-200 bg-background-100 p-1 md:mb-8">
          {tabs.map((item) => (
            <button
              key={item.key}
              type="button"
              onClick={() => setTab(item.key)}
              className={`whitespace-nowrap rounded-full px-4 py-1.5 text-sm font-medium transition-colors ${
                tab === item.key
                  ? "bg-primary-500 text-background-50"
                  : "text-foreground-600 hover:text-foreground-950"
              }`}
            >
              {item.label}
            </button>
          ))}
        </div>
      </div>

      <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-4 md:gap-5">
        {list.map((item, index) => (
          <MediaCard key={item.id} item={item} index={index} />
        ))}
      </div>

      <p className="mt-6 text-center text-xs text-foreground-400">
        正在浏览：{MEDIA_TYPE_LABEL[tab]} · 共 {list.length} 部精选作品
      </p>
    </section>
  );
}